export default __webpack_public_path__ + "static/yokoduna-ed1d1ce402dd5fb61cc0a6431d0a63d4.png";